// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"f23c5e33","246":"ce7ef9fe","483":"fa472fb6","755":"93d643d2","756":"289f0046","815":"412116df"}[chunkId] + ".chunk.js";
};